import { Password } from "@mui/icons-material";
import { getApiUrl } from "../../consts/api";
import { ApiResponse, AuthApi } from "../../types/api";
import { Axios } from "../api/axios";

export const authClient = () => Axios(`${getApiUrl()}/auth`);

export async function getJwt(usr: string, psw: string) {
  const params = { username: usr, password: psw };

  return await authClient().post<ApiResponse<AuthApi>>("/keycloak/jwt", params);
}

export async function sendRefreshToken(refresh_token: string) {
  const params = { refresh_token: JSON.parse(refresh_token) };
  return await authClient().get<ApiResponse<AuthApi>>("/keycloak/logout", {
    params,
  });
}
